import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PheaderComponent } from './raksme.pheadersComponent';
import { HeadersModule } from '../headers/raksme.headerModule';
import { BreadcrumbModule } from 'angular-crumbs';
import { RouterModule } from '@angular/router';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';



@NgModule({
  declarations: [
      PheaderComponent
  ],
  imports: [
    CommonModule,
    HeadersModule,
    BreadcrumbModule,
    RouterModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
      PheaderComponent
  ]
})
export class PageHeadersModule { }
